import { render } from "./SelectProductView.vue?vue&type=template&id=5ddc074c&scoped=true&ts=true"
import script from "./SelectProductView.vue?vue&type=script&lang=ts"
export * from "./SelectProductView.vue?vue&type=script&lang=ts"

import "./SelectProductView.vue?vue&type=style&index=0&id=5ddc074c&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddc074c"]])

export default __exports__